import { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Card, CardGroup, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAccount from "../../../core/api/api.account";
import Switch from "@mui/material/Switch";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";
import { numberRegex } from "../../../core/utils/tools";

export const AddEditeModalAccount = ({
  showModalAccount,
  setShowModalAccount,
  selectedAgencyId,
  selectedAgencyName,
}) => {
  // let location = useLocation();
  // let navigate = useNavigate();
  // let back = (e) => {
  //   e.stopPropagation();
  //   navigate(-1);
  // };
  const [refresh, setRefresh] = useState(false);
  // const [showButton, setShowButton] = useState(false);
  const [accountList, setAccountList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [idAccount, setIdAccount] = useState(0);

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues
  } = useForm({
    defaultValues: { id: 0 },
  });
  const handleClose = () => {
    setShowModalAccount(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (showModalAccount > 0) {
          // انتخاب آژانس
          setAgencyList([{ id: selectedAgencyId, name: selectedAgencyName, managerName: "" }]);
          setValue("agencyId", selectedAgencyId);

          // دریافت اطلاعات حساب جهت ویرایش
          let response = await ApiAccount.getAccountByAgencyId(selectedAgencyId);
          if (response.succeeded == true) {
            // مقدار اولیه
            setAccountList(response.data);
            clean();
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, [refresh]);

  const onSubmit = async (data) => {
    try {
      if (_.toNumber(data.type) === 2 && !(_.isNumber(data.agencyId) && _.toNumber(data.agencyId) > 0)) {
        SwalMessage({ title: "برای حسابهای خارجی آژانس باید تعریف شود", iSsuccess: false });
        return;
      }
      // به کد های سرور اجازه بدیم خودش بره و آژانس مناسب پیدا کند
      if (_.toNumber(data.type) === 1 || _.toNumber(data.type) === 3) {
        data.agencyId = null;
      }
      if (data.type) data.type = data.type.value
      if (data.agencyId) data.agencyId = data.agencyId.value
      let response = null;
      if (_.isNumber(data.id) && _.toNumber(data.id) > 0) {
        //شماره کارت و نام صاحب کارت برای حسابهای کاربر معتبر می باشد
        if (data.type !== "3") {
          data.cardNumber = "";
          data.cardOwnerName = "";
        }
        response = await ApiAccount.updateAccount(data);
      } else response = await ApiAccount.createAccount(data);
      console.log(response)
      if (response.succeeded == true) setRefresh(!refresh);

      handleClose()
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  const clean = () => {
    setIdAccount(0);
    setValue("id", 0);
    setValue("bank", "");
    setValue("accountNumber", "");
    setValue("accountOwnerName", "");
    setValue("description", "");
    setValue("shebaNumber", "");
    setValue("status", false);
    setValue("cardNumber", "");
    setValue("cardOwnerName", "");
    // setValue("type", _.toString(response.data.type));
    // setValue("agencyId", response.data.agencyId);
  };

  const handleChange = (item) => (event) => {
    (async () => {
      try {
        const response = await ApiAccount.changeAccountStatus({ id: item.id, status: !item.status });
        if (response.succeeded == true) setRefresh(!refresh);

        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } catch (error) {
      }
    })();
    return () => { };
  };

  const editItem = (item) => (event) => {
    setIdAccount(item.id);
    // setValue("cardNumber", item.cardNumber);
    // setValue("cardOwnerName", item.cardOwnerName);
    setValue("id", item.id);
    setValue("bank", item.bank);
    setValue("accountNumber", item.accountNumber);
    setValue("accountOwnerName", item.accountOwnerName);
    setValue("description", item.description);
    setValue("shebaNumber", item.shebaNumber);
    setValue("status", item.status);
    setValue("type", _.toString(item.type));
    // setValue("agencyId", item.agencyId);
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" onHide={handleClose} show={showModalAccount}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            {_.isNumber(idAccount) && _.toNumber(idAccount) > 0 ? (
              <Modal.Title> ویرایش حساب </Modal.Title>
            ) : (
              <Modal.Title> افزودن حساب</Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="bank"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام بانک"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.bank && <span className="text-danger">لطفا نام بانک را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="accountNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره حساب"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={(e) => {
                          if (e.target.value && !numberRegex.test(e.target.value)) {
                            e.target.value = getValues("accountNumber")
                            return
                          }
                          onChange(e)
                        }}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="accountOwnerName"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام صاحب حساب"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.accountOwnerName && <span className="text-danger">لطفا نام صاحب حساب را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="shebaNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره شبا"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="description"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="توضیحات"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="type"
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        options={[{ value: 1, label: "داخلی" }, { value: 2, label: "خارجی" }, { value: 3, label: "کاربر" }]}
                        placeholder="گروه"
                        className="w-100 mt-5"
                        variant="outlined"
                        size="small"
                        field={field}
                      />
                    )}
                  />
                  {errors.type && <span className="text-danger">لطفا گروه را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="agencyId"
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        options={agencyList?.map((item) => ({
                          value: item.id,
                          label: item.name + " - " + item.managerName,
                        }))}
                        placeholder="آژانس"
                        className="w-100 mt-5"
                        variant="outlined"
                        size="small"
                        field={field}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <FormControlLabel
                    control={
                      <Controller
                        name="status"
                        control={control}
                        render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                          <Checkbox
                            onBlur={onBlur}
                            onChange={onChange}
                            checked={value}
                            inputRef={ref}
                            color="primary"
                          />
                        )}
                      />
                    }
                    label="فعال "
                  />
                </Col>
                {_.isNumber(idAccount) && _.toNumber(idAccount) === 0 ? (
                  <>
                    <Col xs="12">
                      <Controller
                        name="cardNumber"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="شماره کارت"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={(e) => {
                              if (e.target.value && (!numberRegex.test(e.target.value) || e.target.value.length > 16)) {
                                e.target.value = getValues("accountNumber")
                                return
                              }
                              onChange(e)
                            }} />
                        )}
                      />
                    </Col>
                    <Col xs="12">
                      <Controller
                        name="cardOwnerName"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="نام صاحب کارت"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            value={value || ""}
                            onInput={onChange}
                          />
                        )}
                      />
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </Row>

              <Row className="pt-4">
                <Col xs="12">
                  <Button variant="success" className="mx-1" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SaveIcon /> {idAccount > 0 ? " ویرایش " : " ذخیره "}
                  </Button>
                  {/* <Button variant="success" className="mx-1" onClick={onSubmit2} >
                                            <SaveIcon />  {(idAccount > 0) ? " ویرایش " : " ذخیره "}
                                        </Button> */}
                  {/* <Button variant="success" type="submit">
                                            <SaveIcon /> {(location != null && location.state != null && location.state.id != "0") ? " ویرایش " : " ذخیره "}
                                        </Button> */}
                  <Button variant="danger" className="mx-1" onClick={clean}>
                    <CloseIcon /> پاک کردن
                  </Button>
                </Col>
              </Row>
            </Col>
            {!_.isEmpty(accountList) ? (
              <Col className="pt-6">
                <CardGroup className="text-center ">
                  <Card>
                    {" "}
                    <Card.Text> نام صاحب حساب </Card.Text>{" "}
                  </Card>
                  <Card>
                    {" "}
                    <Card.Text> شماره حساب </Card.Text>{" "}
                  </Card>
                  <Card>
                    {" "}
                    <Card.Text> وضعیت </Card.Text>{" "}
                  </Card>
                  <Card>
                    {" "}
                    <Card.Text> ... </Card.Text>{" "}
                  </Card>
                </CardGroup>
                {accountList?.map((item, Index) => (
                  <CardGroup key={Index} className="text-center align-text-middle justify-content-center">
                    <Card className="justify-content-center">
                      <Card.Text>{item.accountOwnerName}</Card.Text>
                    </Card>
                    <Card className="justify-content-center">
                      <Card.Text>{item.accountNumber}</Card.Text>
                    </Card>
                    <Card className="justify-content-center">
                      <Card.Text>
                        <Switch
                          checked={item.status ? true : false}
                          value="row.original.active"
                          color="primary"
                          inputProps={{ "aria-label": "primary checkbox" }}
                          onChange={handleChange(item)}
                        />
                      </Card.Text>
                    </Card>
                    <Card className="justify-content-center">
                      <Card.Text>
                        <Button onClick={editItem(item)}>
                          <i className="far fa-edit text-small"></i>
                        </Button>
                      </Card.Text>
                    </Card>
                  </CardGroup>
                ))}
              </Col>
            ) : (
              <></>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
